var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileCircleCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0C0.896875 0 0 0.896875 0 2V14C0 15.1031 0.896875 16 2 16H7.625C6.91563 15.0156 6.5 13.8062 6.5 12.5C6.5 9.35625 8.91875 6.775 12 6.52188V5.33125C12 4.8 11.7906 4.29063 11.4156 3.91563L8.08438 0.584375C7.70938 0.209375 7.20312 0 6.67188 0H2ZM10.1719 5.5H7.25C6.83437 5.5 6.5 5.16563 6.5 4.75V1.82812L10.1719 5.5ZM17 12.5C17 10.0156 14.9844 8 12.5 8C10.0156 8 8 10.0156 8 12.5C8 14.9844 10.0156 17 12.5 17C14.9844 17 17 14.9844 17 12.5ZM14.2938 10.5969C14.5156 10.7594 14.5656 11.0719 14.4031 11.2937L12.4031 14.0438C12.3156 14.1625 12.1844 14.2375 12.0375 14.2469C11.8906 14.2563 11.7469 14.2062 11.6438 14.1031L10.3938 12.8531C10.2 12.6594 10.2 12.3406 10.3938 12.1469C10.5875 11.9531 10.9062 11.9531 11.1 12.1469L11.9375 12.9844L13.5938 10.7063C13.7563 10.4844 14.0688 10.4344 14.2938 10.5969Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCircleCheck);
export default __webpack_public_path__ + "static/media/file-circle-check.6bf0612a4ad914f4034d4e18247666a6.svg";
export { ForwardRef as ReactComponent };